import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { Experiments } from '@src/constants/abTest';
import { useTestVariant } from '@src/hooks/useTestVariants';
import { useHasUtmLabel } from '@src/reducers/route';
import { isMainPage, isProverennyeZaymyPage } from '@src/utils/routing';

import { isShowCalculatorByQuery } from './isShowCalculatorByQuery';

export const useIsShowFullDealEntrypoint = () => {
  const hasUtmLabel = useHasUtmLabel();
  const { asPath, query } = useRouter();
  const isPageWithoutAbTest = isProverennyeZaymyPage(asPath);
  const isMain = isMainPage(asPath, query);
  const { isBVariant: isBVariantForContext } = useTestVariant(Experiments.FULL_DEAL_CONTEXT_ENTRY_BLOCK);
  const isShowCalculator = isShowCalculatorByQuery(query);

  return useMemo(() => {
    if (isShowCalculator === true) {
      return true;
    }

    if (isShowCalculator === false || (isMain && hasUtmLabel)) {
      return false;
    }

    if ((hasUtmLabel && isBVariantForContext) || isPageWithoutAbTest) {
      return true;
    }

    return !hasUtmLabel;
  }, [isShowCalculator, hasUtmLabel, isBVariantForContext, isPageWithoutAbTest, isMain]);
};
